import { useStore } from 'react-redux';
import { translateBase } from '@/utils/tools';

export default function useCustomStoreHooks() {
  const { getState, dispatch } = useStore();
  const store = getState();

  function translate({ translate_language_key, key }) {
    return translateBase({ translate_language_key, key, store });
  }
  return { store, dispatch, translate };
}
